var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGalerie(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 682.667 682.667",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 512h512V0H0Z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 682.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-328.205c-20.634 0-37.362 16.728-37.362 37.363v211.902c0 34.987 28.362 63.35 63.35 63.35H0c20.635 0 37.363-16.728 37.363-37.363V37.363C37.363 16.728 20.635 0 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(375.567 141.653)",
    fill: "#EE4E71",
    "data-original": "#ee4e71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-328.205c-20.634 0-37.362 16.728-37.362 37.363v211.902c0 34.987 28.362 63.35 63.35 63.35H0c20.635 0 37.363-16.728 37.363-37.363V37.363C37.363 16.728 20.635 0 0 0Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(375.567 141.653)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: "20px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-328.205c-20.635 0-37.362 16.728-37.362 37.363v236.115c0 21.614 17.522 39.137 39.136 39.137H0c20.635 0 37.363-16.728 37.363-37.363V37.363C37.363 16.728 20.635 0 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(418.066 99.582)",
    fill: "#FFD866",
    "data-original": "#ffd866"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124.103c20.634 0 37.362-16.728 37.362-37.363v-237.889c0-20.635-16.728-37.363-37.362-37.363h-328.205c-20.635 0-37.363 16.728-37.363 37.363v236.115C-241.465-17.522-223.943 0-202.328 0H-80",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(293.964 412.197)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: "20px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-337.913c-17.954 0-32.509 14.555-32.509 32.509v247.597c0 17.955 14.555 32.509 32.509 32.509H0c17.954 0 32.509-14.554 32.509-32.509V32.509C32.509 14.555 17.954 0 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(469.491 57.732)",
    fill: "#D6EFFB",
    "data-original": "#d6effb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-337.913c-17.954 0-32.509 14.555-32.509 32.509v247.597c0 17.955 14.555 32.509 32.509 32.509H0c17.954 0 32.509-14.554 32.509-32.509V32.509C32.509 14.555 17.954 0 0 0Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(469.491 57.732)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: "20px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h337.913c17.954 0 32.508 14.555 32.508 32.509v63.776l-59.528 44.965a23.567 23.567 0 0 1-28.082.242l-62.049-45.207L109.777 210.71c-8.76 9.033-23.072 9.589-32.508 1.265l-109.778-96.852V32.509C-32.509 14.555-17.955 0 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(131.579 57.732)",
    fill: "#00B7EC",
    "data-original": "#00b7ec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h337.913c17.954 0 32.508 14.555 32.508 32.509v63.776l-59.528 44.965a23.567 23.567 0 0 1-28.082.242l-62.049-45.207L109.777 210.71c-8.76 9.033-23.072 9.589-32.508 1.265l-109.778-96.852V32.509C-32.509 14.555-17.955 0 0 0Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(131.579 57.732)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: "20px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 94.262-97.185",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(288.72 219.61)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: "20px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-18.112-14.683-32.795-32.795-32.795-18.113 0-32.796 14.683-32.796 32.795 0 18.112 14.683 32.795 32.796 32.795C-14.683 32.795 0 18.112 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(421.31 276.858)",
    fill: "#FFD866",
    "data-original": "#ffd866"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-18.112-14.683-32.795-32.795-32.795-18.113 0-32.796 14.683-32.796 32.795 0 18.112 14.683 32.795 32.796 32.795C-14.683 32.795 0 18.112 0 0Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(421.31 276.858)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: "20px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v0",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(253.964 412.197)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: "20px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalerie);
export default __webpack_public_path__ + "static/media/Galerie.c402c7853f0c891ef6a8ca93d5fbab41.svg";
export { ForwardRef as ReactComponent };